import styled from 'styled-components';
import { DEFAULT_PADDING, MD_FONT_SIZE, PRIMARY_COLOR, SEMI_FONT_WEIGHT, SM_FONT_SIZE, SM_PADDING } from '../Common/StyleElement';

export const TextFieldTitle = styled.div`
    display: inline-flex;
    font-size: ${MD_FONT_SIZE};
    font-weight: ${SEMI_FONT_WEIGHT};
    padding-bottom: ${SM_PADDING};
`

export const TextFieldInput = styled.textarea`
    resize: none;
    height: 200px;
    width: 100%;
    border: 4px solid ${PRIMARY_COLOR};
    border-radius: 20px;
    padding: ${DEFAULT_PADDING};
    font-size: ${SM_FONT_SIZE};
`